module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.fetchData) ? _c('div', {
    staticClass: "content block__width-995 fullpage-container"
  }, [_c('full-page', {
    attrs: {
      "options": _vm.options
    },
    on: {
      "after-load": _vm.afterLoad
    }
  }, [_c('div', {
    staticClass: "section",
    attrs: {
      "data-menuanchor": "page1",
      "id": "section1"
    }
  }, [_c('div', {
    staticClass: "chart"
  }, [_c('div', {
    staticClass: "chart__title"
  }, [_vm._v(_vm._s(_vm.chartTitle))]), _vm._v(" "), _c('div', {
    staticClass: "chart-block"
  }, [_c('div', {
    staticClass: "chart__address"
  }, [_vm._v("\n                " + _vm._s(_vm.chartAddress) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "chart__value"
  }, [_vm._v("\n                " + _vm._s(_vm.chartValue) + "\n                "), _c('span', [_vm._v("\n                  мгм/м3\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chart__interactive"
  }, [_c('div', {
    staticClass: "chart__info"
  }, [_c('div', {
    staticClass: "chart__info-top",
    style: (_vm.infoStyle)
  }, [_c('div', {
    staticClass: "chart__info-top-title"
  }, [_vm._v("\n                  " + _vm._s(_vm.infoTitle) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "chart__info-top-desc"
  }, [_vm._v("\n                  " + _vm._s(_vm.infoDesc) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "chart__info-bottom"
  }, [_c('div', {
    staticClass: "chart__info-bottom-item chart__info-bottom-item1"
  }, [_c('div', {
    staticClass: "chart__info-bottom-label"
  }, [_vm._v("Температура"), _c('br'), _vm._v("C")]), _vm._v(" "), _c('div', {
    staticClass: "chart__info-bottom-value"
  }, [_vm._v(_vm._s(_vm.infoHumidity))])]), _vm._v(" "), _c('div', {
    staticClass: "chart__info-bottom-item chart__info-bottom-item2"
  }, [_c('div', {
    staticClass: "chart__info-bottom-label"
  }, [_vm._v("Влажность"), _c('br'), _vm._v("%")]), _vm._v(" "), _c('div', {
    staticClass: "chart__info-bottom-value"
  }, [_vm._v(_vm._s(_vm.infoTemp))])])])]), _vm._v(" "), _c('div', {
    staticClass: "chart__diagram"
  }, [_c('div', {
    staticClass: "custom-select"
  }, [_c('div', {
    staticClass: "custom-select__item custom-select__item1",
    class: {
      customSelecActive: _vm.activeLink === 1
    },
    on: {
      "click": function($event) {
        _vm.changePeriod('day', 1)
      }
    }
  }, [_vm._v("за сутки")]), _vm._v(" "), _c('div', {
    staticClass: "custom-select__item",
    class: {
      customSelecActive: _vm.activeLink === 2
    },
    on: {
      "click": function($event) {
        _vm.changePeriod('week', 2)
      }
    }
  }, [_vm._v("за неделю")])]), _vm._v(" "), _c('line-chart', {
    staticClass: "line-chart",
    attrs: {
      "fetchData": _vm.fetchData,
      "chartPeriod": _vm.chartPeriod
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "scroll-button",
    on: {
      "click": this.moveSectionDown
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "section",
    attrs: {
      "id": "section2",
      "data-menuanchor": "page2"
    }
  }, [_c('div', {
    staticClass: "map-desc"
  }, [_vm._v("\n          Нажмите на маркер, чтобы посмотреть данные этого датчика\n        ")]), _vm._v(" "), _c('GmapMap', {
    staticStyle: {
      "width": "100%",
      "height": "450px"
    },
    attrs: {
      "center": {
        lat: 42.874602,
        lng: 74.609141
      },
      "zoom": 13
    }
  }, _vm._l((_vm.markers), function(m, index) {
    return _c('GmapMarker', {
      key: index,
      attrs: {
        "icon": m.icon,
        "position": m.position,
        "clickable": true,
        "draggable": false
      },
      on: {
        "click": function($event) {
          _vm.buildMap(m.position)
        }
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "scroll-button",
    on: {
      "click": this.moveSectionDown
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "section",
    attrs: {
      "id": "section3",
      "data-menuanchor": "page3"
    }
  }, [_c('info', {
    attrs: {
      "fetchData": _vm.fetchData
    }
  })], 1)])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f463e6c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VueChartJS.vue
// module id = 324
// module chunks = 1